import { DrawingImportError, normalizeDrawingObject } from "./DrawingStorage";
export const DRAWING_SCHEMA_VERSION = 1;
export function serializeDrawingObject(drawing) {
    return JSON.stringify(drawing);
}
export function deserializeDrawingObject(payload) {
    try {
        return JSON.parse(payload);
    }
    catch {
        return null;
    }
}
export function serializeDrawings(drawings) {
    return JSON.stringify(drawings);
}
/**
 * P1-01: parse failures THROW `DrawingImportError` instead of silently returning `[]`,
 * so corrupt cache keys are cleared+warned by the storage adapter instead of rotting.
 * Accepts both legacy flat arrays and `{schemaVersion, drawings}` wrappers (P1-02);
 * item-level normalization stays in the adapter (`normalizeDrawings`).
 */
export function deserializeDrawings(payload) {
    let parsed;
    try {
        parsed = JSON.parse(payload);
    }
    catch {
        throw new DrawingImportError("Drawing payload is not valid JSON");
    }
    if (Array.isArray(parsed)) {
        return parsed;
    }
    if (parsed !== null && typeof parsed === "object" && Array.isArray(parsed.drawings)) {
        const wrapper = parsed;
        // v0 wrappers still need migration; v1+ items are normalized downstream.
        if ((wrapper.schemaVersion ?? 0) < 1) {
            return migrateDrawings(wrapper.drawings, 0);
        }
        return wrapper.drawings;
    }
    throw new DrawingImportError("Drawing payload must be an array or a versioned drawings wrapper");
}
export function serializeDrawingHistory(history) {
    return JSON.stringify(history);
}
export function deserializeDrawingHistory(payload) {
    try {
        return JSON.parse(payload);
    }
    catch {
        return null;
    }
}
/** Export drawings wrapped with a schema version block */
export function exportDrawingsJSON(drawings) {
    return JSON.stringify({
        schemaVersion: DRAWING_SCHEMA_VERSION,
        drawings,
    });
}
/**
 * Import drawings, seamlessly supporting both legacy flat arrays and wrapped payloads.
 * P1-01: invalid JSON THROWS `DrawingImportError` (previously swallowed to `[]`).
 */
export function importDrawingsJSON(raw) {
    let parsed;
    try {
        parsed = JSON.parse(raw);
    }
    catch {
        throw new DrawingImportError("Drawing payload is not valid JSON");
    }
    if (Array.isArray(parsed)) {
        return migrateDrawings(parsed, 0);
    }
    const payload = parsed;
    if (payload !== null && typeof payload === "object" && Array.isArray(payload.drawings)) {
        return migrateDrawings(payload.drawings, payload.schemaVersion ?? 0);
    }
    throw new DrawingImportError("Drawing payload must be an array or a versioned drawings wrapper");
}
function migrateDrawings(drawings, fromVersion) {
    let result = drawings;
    if (fromVersion < 1) {
        // v0 -> v1: All items are normalized safely, translating fibLevels -> fibLevelConfigs, etc.
        result = result.map((item, index) => normalizeDrawingObject(item, index));
    }
    return result;
}
